import {ReactNode} from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "../hooks/useAuth.ts";
// REGISTRATION-PAUSE (FNP-1222) — TEMPORARY: remove this import and the guard
// below to restore the sign-up redirect. See src/config/registration.ts.
import {isRegistrationEnabled} from "../config/registration";


export const RequireAuth = ({children}: { children: ReactNode }) => {
    const {user} = useAuth();
    const location = useLocation();

    if (!user) {
        // Preserve productId and returnTo parameters when redirecting to signup
        const searchParams = new URLSearchParams(location.search);
        const productId = searchParams.get('productId');
        const returnTo = searchParams.get('returnTo');

        // REGISTRATION-PAUSE (FNP-1222): while registration is closed, send an
        // unauthenticated visitor to sign-in instead of into the sign-up flow.
        if (!isRegistrationEnabled()) {
            return <Navigate to="/sign-in"/>;
        }

        if (productId || returnTo) {
            const signupParams = new URLSearchParams();
            if (productId) signupParams.set('productId', productId);
            if (returnTo) signupParams.set('returnTo', returnTo);
            return <Navigate to={`/sign-up?${signupParams.toString()}`}/>;
        }

        return <Navigate to="/"/>;
    }
    return children;
};
